<template>
  <v-app
    id="app"
    :class="{
      'light-theme': theme === 'light-theme',
      'dark-theme': theme === 'dark-theme',
    }"
  >
    <Navbar v-if="user" />
<NotificationButton/>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/atoms/Navbar";
import NotificationButton from "@/components/atoms/NotificationButton"
import { mapState } from "vuex";
export default {
  components: {
    Navbar,
    NotificationButton
  },
  data() {
    return {
      showInviteForm: false,
    };
  },
  computed: mapState({
    user: (state) => state.profiles.ownProfile,
    theme: (state) => state.global.theme,
    alert: (state) => state.global.alert,
  })
};
</script>

<style lang="scss">
@import "./assets/sass/style.scss";
@import "./assets/sass/variables.scss";
</style>